import { defineStore } from 'pinia'
import { useCurrentUserStore } from './CurrentUserStore';
export const usePermissionStore = defineStore('permissionStore', {
    state: () => (
        { 
            list: 0, 
            loading : false, 
            data : {}
        }),
    actions: {
    },
  })